/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 * GTM events for Widget Personal Account
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Julia Ignatieva
 * @version 1.12.0
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

export enum EGTMWidgetPersonalAccountCloseType {
    cancelBtnIcon = 'Кнопка закрытия',
    cancelLink = 'Отмена',
}

export const clickLinkWidgetPersonalAccount: IGTMOperation = ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e2',
    'event_cat': 'Лицевой счет',
    'event_name': 'clickElement',
    'event_param': 'Лицевой счет',
});

export const clickLinkHowToGetCashbackWidgetPersonalAccount = (url: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e3',
    'event_cat': 'Лицевой счет',
    'event_name': 'clickElement',
    'event_param': url,
});

export const clickLinkCashbackControlWidgetPersonalAccount = (url: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e2',
    'event_cat': 'Лицевой счет',
    'event_name': 'clickElement',
    'event_param': url,
});

export const clickLinkShowBillingsWidgetPersonalAccount: IGTMOperation = ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e4',
    'event_cat': 'Лицевой счет',
    'event_name': 'clickElement',
    'event_param': 'Посмотреть выставленные счета',
});

export const clickLinkAmountUnpaidBillsWidgetPersonalAccount: IGTMOperation = ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e5',
    'event_cat': 'Лицевой счет',
    'event_name': 'clickElement',
    'event_param': 'счета',
});

export const clickBtnBillsWidgetPersonalAccount: IGTMOperation = ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v217-e6',
    'event_cat': 'Лицевой счет',
    'event_name': 'submit1',
    'event_param': 'Выставить счет на предоплату',
});

export const clickBtnMakeReportWidgetPersonalAccount = (prepaySum: string): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v217-e7',
    'event_cat': 'popUp / Счёт на предоплату',
    'event_name': 'submit',
    'event_param': prepaySum,
});

export const makeReportSuccessWidgetPersonalAccount = (prepaySum: string): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v217-e8',
    'event_cat': 'popUp / Счёт на предоплату',
    'event_name': 'sendSuccess',
    'event_param': prepaySum,
});

export const makeReportErrorWidgetPersonalAccount = (error: string): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v217-e9',
    'event_cat': 'popUp / Счёт на предоплату',
    'event_name': 'sendError1',
    'event_param': error,
});

export const clickBtnCloseMakeReportWidgetPersonalAccount =
    (cancelType: EGTMWidgetPersonalAccountCloseType): IGTMOperation => ({
        'event': 'addEvents_makeActions',
        'event_id': 'd-v217-e10',
        'event_cat': 'popUp / Счёт на предоплату',
        'event_name': 'closePopUp',
        'event_param': cancelType,
    });
